import {
	useMutation,
	useQueryClient,
	useSuspenseQuery,
} from "@tanstack/react-query";
import type { TikTokAdsReport } from "shared";
import { Api } from "../api.config";
import { AlertType, useAlertEmit } from "../common/alert/Alert";
import { useCompany } from "../company/useCompany";
import { QueryKeys } from "../LinkGen";

export const useTikTokAdsReport = (days: number) => {
	const { id: companyId } = useCompany();

	return useSuspenseQuery({
		queryKey: QueryKeys.Integrations.TikTokAds.Report(companyId, days),
		queryFn: (): Promise<TikTokAdsReport> =>
			Api.GetTikTokAdsReport(days).then((res) => res.data),
	});
};

export const useTikTokAdsSync = (days: number) => {
	const { id: companyId } = useCompany();
	const queryClient = useQueryClient();
	const emit = useAlertEmit();

	return useMutation({
		mutationFn: async () => {
			const report = await Api.SyncTikTokAdsInsights(days).then(
				(res) => res.data,
			);
			queryClient.setQueryData(
				QueryKeys.Integrations.TikTokAds.Report(companyId, days),
				report,
			);
			emit({
				type: AlertType.SUCCESS,
				content: "TikTok Ads performance data refreshed",
			});
		},
		onError: () => {
			emit({
				type: AlertType.ERROR,
				content: "Could not refresh TikTok Ads performance data",
			});
		},
	});
};
